/**
 * @flow
 * @relayHash d4f0f1f4853fe805de5cdcc826474ede
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VocabularyEditInput = {
  id: string,
  name: string,
  value: string,
  description: string,
  clientMutationId?: ?string,
};
export type vocabularyEditMutationVariables = {|
  input: VocabularyEditInput
|};
export type vocabularyEditMutationResponse = {|
  +VocabularyEdit: ?{|
    +error: ?string,
    +vocabulary: ?{|
      +id: string
    |},
  |}
|};
export type vocabularyEditMutation = {|
  variables: vocabularyEditMutationVariables,
  response: vocabularyEditMutationResponse,
|};
*/


/*
mutation vocabularyEditMutation(
  $input: VocabularyEditInput!
) {
  VocabularyEdit(input: $input) {
    error
    vocabulary {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VocabularyEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "VocabularyEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "VocabularyEditInput!"
      }
    ],
    "concreteType": "VocabularyEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vocabulary",
        "storageKey": null,
        "args": null,
        "concreteType": "Vocabulary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "vocabularyEditMutation",
  "id": null,
  "text": "mutation vocabularyEditMutation(\n  $input: VocabularyEditInput!\n) {\n  VocabularyEdit(input: $input) {\n    error\n    vocabulary {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "vocabularyEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "vocabularyEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b885daa68e68fd71d04b4c248ccf024';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/mutations/__generated__/vocabularyEditMutation.graphql.js